/**
 * ns.wow Notes
 * Facade class for public accessible core functionality.
 */

import $ from "jquery";
import 'element-closest-polyfill';


class NSNotes {


  static version() {
    return NSContext.plugins.notes.version;
  }


  static init() {
    // Replace HTML with A-tags and Ajax calls (admin-ajax.php)

    let $notes = $(NSContext.plugins.notes.noteSelector);
    let $notesText = $('a[href*="?note="]'); 
    let $notesMixedText = $('a[href*="?notemix="]');
    $notes.each( (index, element) => {
      NSNotes.createLink(element);
    });

    $notesText.each( (index, element) => {
      NSNotes.createLinkInText(element, false);
    });

    $notesMixedText.each( (index, element) => {
      NSNotes.createLinkInText(element, true);
    });

    //triggers when note Links are added, in case of a async function
    //$(document).trigger("noteLinksAdded");

    // Add popup box to show the linked notes
    $('body').append(`<div class="nhsnote-box">
			<div class="nhsnote-box__background js-nhsnote-box-close"></div>
			<div class="nhsnote-box__inner js-nhsnote-box-inner">
				<button class="nhsnote-box__close js-nhsnote-box-close"></button>
				<div class="nhsnote-box__content js-nhsnote-box-content"></div>
			</div>
		</div>`);


    $(document).keyup(function(event) {
      if (event.keyCode === 27) {
        let element = event.target;
        NSNotes.closePopup(element); 
      }
    });

    $(document).on('click', `.${NSContext.plugins.notes.noteLinkClass}`, (event) => {
      let element = event.target;
      NSNotes.openPopup(element);
      return false;
    });
    
    
    $(document).on('click', '.js-nhsnote-box-close', (event) => {
      let element = event.target;
      NSNotes.closePopup(element);
    });

  }

  static createLinkInText(element, isMixed) {
    let $note = $(element);
    let innerHtml = $note.attr('href');
    let reg = new RegExp(/\d+$/g);
    const noteNumber = reg.exec(innerHtml)[0];
    let modalClass = '';

    if (typeof $note.attr('data-modal-class') !== 'undefined') {
      modalClass = $note.attr('data-modal-class');
    }

    if (noteNumber === '&nbsp;') {
      $note.hide();
      return true;
    } else if (noteNumber === 'Note') {
      return true;
    }

    let category = NSContext.plugins.notes.matchedCategory;
    //when no category, then check if we have a dataset-id to get the category. If there is no category and we have the term "notemix", check the url - get the last part of the url, which is the slug of the category and compare this to the array of all categories. When one is found, take the id as var category.
    if(!category && !isMixed){
      let accordion = element.closest(".mms-accordion-container--inner--wrapper .wrapper");
      if(accordion && accordion != undefined){
        category = element.closest(".mms-accordion-container--inner--wrapper .wrapper").dataset.termId;
      }
    }else if(!category && isMixed) {
      console.log("penis");
      let accordion = element.closest(".mms-accordion-container--inner--wrapper .wrapper");
      let url = innerHtml.split('?notemix=')[0]; 
      let urlArray = url.split('/');
      let theCatIdentifier = '';
      //get the lastpart of url, which is the slug of the category
      if(urlArray[urlArray.length-1] !== '') {
        theCatIdentifier = urlArray[urlArray.length-1];
      } else {
        theCatIdentifier = urlArray[urlArray.length-2];
      }
      console.log(theCatIdentifier);

      if(accordion && accordion != undefined){
        let catArray = element.closest(".mms-accordion-container--inner--wrapper .wrapper").dataset.allTerms;
        catArray = catArray.split(' ');
        //compare the category-slug with the array of all category-slugs in data-all-term. If one is found, take the ID
        catArray.forEach((element) => {
          let theCat = element.split('--');
          console.log(theCat);
          if(theCat[0].replace('_de', '_en') == theCatIdentifier) {
            category = theCat[1];
          }
        });
      }
    }
    // Notes if more than one Number/Note is in the trigger
    let values = '';
    let separator = '';

    if (innerHtml.indexOf('/') !== -1) {
      values = innerHtml.split('/');
      separator = '/';
    } else {
      values = innerHtml.split(',');
      separator = ',';
    }

    const note = values[values.length - 1].trim();
    const url = `${NSContext.site.ajaxUrl}?action=${NSContext.plugins.notes.ajaxAction}&lang=en&term_id=${category}&note=${note.replace(/\u00e4/g, "ae").replace(/\u00fc/g, "ue").replace(/\u00f6/g, "oe").replace(/\?note=/g, "").replace(/\?notemix=/g, "")}&class=${modalClass}`;
    $note.attr('href', '');
    $note.addClass(NSContext.plugins.notes.noteLinkClass);
    $note.attr('data-href', url);
  }


  static createLink(element) {

    let $note = $(element);
    const innerHtml = $note.html();
    const noteNumber = NSNotes.getNoteId(innerHtml.trim());
    let modalClass = '';

    if (typeof $note.attr('data-modal-class') !== 'undefined') {
      modalClass = $note.attr('data-modal-class');
    }

    if (noteNumber === '&nbsp;') {
      $note.hide();
      return true;
    } else if (noteNumber === 'Note') {
      return true;
    }

    let category = NSContext.plugins.notes.matchedCategory;

    if (!category) {
      let accordion = element.closest(".mms-accordion-container--inner--wrapper .wrapper");
      if(accordion && accordion != undefined){
        category = element.closest(".mms-accordion-container--inner--wrapper .wrapper").dataset.termId;
      }
    }

    // Notes if more than one Number/Note is in the trigger
    let values = '';
    let separator = '';

    if (innerHtml.indexOf('/') !== -1) {
      values = innerHtml.split('/');
      separator = '/';
    } else {
      values = innerHtml.split(',');
      separator = ',';
    }

    let resolvedNotes = [];

    for (let i = 0; i < values.length; i++) {
      const note = values[i].trim();
      const url = `${NSContext.site.ajaxUrl}?action=${NSContext.plugins.notes.ajaxAction}&lang=en&term_id=${category}&note=${note.replace(/\u00e4/g, "ae").replace(/\u00fc/g, "ue").replace(/\u00f6/g, "oe")}&class=${modalClass}`;
      resolvedNotes.push(`<a data-href="${url}" class="${NSContext.plugins.notes.noteLinkClass}">${note}</a>`);
    }

    resolvedNotes = resolvedNotes.join(separator);
    $note.html(resolvedNotes);
    $(document).trigger("noteLinksAdded");
  }


  static getNoteId(string) {

    let output = '';
    output = string.replace(".", "\\.");
    output = output.replace("(", "");
    output = output.replace(")", "");
    return output;

  }


  static openPopup(element) {
    const $box = $('.nhsnote-box');
    const $boxInner = $box.find('.js-nhsnote-box-inner');
    const $boxContent = $box.find('.js-nhsnote-box-content');

    $box.fadeIn();
    $.ajax({
      url: $(element).attr('data-href'),
    }).always((data) => {
      $box.addClass('nhsnote-box--loaded');
      $boxContent.html(data);
      $boxInner.fadeIn();
      $(document).trigger("noteLoaded");
      window.dispatchEvent(new Event('resize'));
      document.querySelector('body').classList.add('notes-open');
    });

  }


  static closePopup(element) {

    const $box = $('.nhsnote-box');
    const $boxInner = $box.find('.js-nhsnote-box-inner');
    const $boxContent = $box.find('.js-nhsnote-box-content');

    document.querySelector('body').classList.remove('notes-open');

    $boxInner.fadeOut(() => {
      $boxContent.html('');
      $box.removeClass('nhsnote-box--loaded');
    });
    $box.fadeOut();
    $(document).trigger("noteClosed");

  }
}

export default NSNotes;
